import { Stack } from '@mui/material'
import { TableCellProps } from '@mui/material/TableCell/TableCell'
import { roundingNumber } from 'components/shared/processes'
import { Milkings } from 'models/IFarm'
import { CustomTableRowProps } from 'ui/table/CustomTableRow'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'

interface useGetCellOptionsProps {
	milkings: Milkings[]
	total_reject_milk_sum: number
	total_sell_milk_sum: number
}

export const useGetCellOptions = ({
	milkings,
	total_reject_milk_sum,
	total_sell_milk_sum,
}: useGetCellOptionsProps) => {
	const totalToSellRaw = milkings.reduce(
		(sum, el) => sum + (el.to_sell ?? 0),
		0,
	)
	const totalRejectedMilkRaw = milkings.reduce(
		(sum, el) => sum + (el.rejected_milk ?? 0),
		0,
	)
	const totalToSell = roundingNumber(totalToSellRaw, 1)
	const totalRejectedMilk = roundingNumber(totalRejectedMilkRaw, 1)
	const totalMilk = totalToSell + totalRejectedMilk

	const TABLE_OPTIONS: CustomTableRowProps[] = [
		{
			rowKey: 'toSellRow',
			rowHeight: '18px',
			cellItems: [
				{
					padding: '4px 0px 0px 0px',
					children: (
						<Stack direction='row' alignItems='center' gap='4px'>
							<span
								style={{
									width: '8px',
									height: '8px',
									backgroundColor: '#1976d2',
									borderRadius: '50%',
									display: 'inline-block',
								}}
							/>
							<TypographyPrimary>Товарное</TypographyPrimary>
						</Stack>
					),
					align: 'left' as TableCellProps['align'],
				},
				{
					padding: '4px 0px 0px 0px',
					children: total_sell_milk_sum === 0 ? 0 : total_sell_milk_sum,
					align: 'left' as TableCellProps['align'],
				},
				{
					padding: '4px 0px 0px 0px',
					children:
						totalMilk === 0
							? '-'
							: roundingNumber((totalToSell / totalMilk) * 100, 0),
					align: 'right' as TableCellProps['align'],
				},
			],
		},
		{
			rowKey: 'rejectedMilkRow',
			rowHeight: '18px',
			cellItems: [
				{
					padding: '4px 0px 0px 0px',
					children: (
						<Stack direction='row' alignItems='center' gap='4px'>
							<span
								style={{
									width: '8px',
									height: '8px',
									backgroundColor: '#d32f2f',
									borderRadius: '50%',
									display: 'inline-block',
								}}
							/>
							<TypographyPrimary>Бракованное</TypographyPrimary>
						</Stack>
					),
					align: 'left' as TableCellProps['align'],
				},
				{
					padding: '4px 0px 0px 0px',
					children: total_reject_milk_sum === 0 ? 0 : total_reject_milk_sum,
					align: 'left' as TableCellProps['align'],
				},
				{
					padding: '4px 0px 0px 0px',
					children:
						totalMilk === 0
							? '-'
							: roundingNumber((totalRejectedMilk / totalMilk) * 100, 0),
					align: 'right' as TableCellProps['align'],
				},
			],
		},
	]

	return TABLE_OPTIONS
}
